import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
const firebaseConfig = {
  apiKey: "AIzaSyDyBgYy3MyUToyEgcpFAdXxbFUcqVtSg7Q",
  authDomain: "denial-enterprise.firebaseapp.com",
  projectId: "denial-enterprise",
  storageBucket: "denial-enterprise.firebasestorage.app",
  messagingSenderId: "1046073769551",
  appId: "1:1046073769551:web:71a9a395296c83d685b43a",
  measurementId: "G-QFJBJ4CZN9"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Database and Storage for use in components
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);